export default __webpack_public_path__ + "static/media/fireFN27.f4940fda.svg";